import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SiteSelectorService } from 'app/core/services/site.service';
import { SiteLicenseState } from 'app/core/models';

/**
 * 根據 site id 從 SiteSelectorService 獲取授權狀態
 * 使用 Observable 方式，當 _siteLicenseStates 變化時會自動更新
 */
@Pipe({
    name: 'SiteLicense',
    pure: true
})
export class SiteLicensePipe implements PipeTransform {

    constructor(private siteSelectorService: SiteSelectorService) { }

    transform(siteId: string): Observable<SiteLicenseState | null> {
        if (!siteId) {
            return new Observable(observer => observer.next(null));
        }

        return this.siteSelectorService.$siteLicenseStates.pipe(
            map(statesMap => statesMap.get(siteId) || null)
        );
    }
}
